import request from '../request';

export const getFieldTypes = () => {
  return request.get('fieldtypes').then((res) => res);
};
